import { LocalizationHelper } from "../../helpers"

import { OpChangeState, Enums } from "../common/enums"
import { OpDevice } from "./op-device"
import { OpMeter } from "./op-meter"
import { OpLocation } from "./op-location"
import { OpActionType } from "./op-action-type"
import { OpActionStatus } from "./op-action-status"
import { OpActionData } from "./op-action-data"
import { OpModule } from "./op-module"
import { OpOperator } from "./op-operator"

import { ObjectCustomString, OpDataList } from "../util"
import { IOpChangeState, IReferenceType, IOpObject } from "../util/interfaces"

export class OpAction implements IOpChangeState, IReferenceType, IOpObject {
    
    //#region Properties

    public idAction: number
    public serialNbr: number
    public idMeter: number
    public idLocation: number
    public idActionType: number
    public idActionStatus: number
    public idActionData: number
    public idActionParent: number
    public idModule: number
    public idOperator: number
    public creationDate: Date
    public opState: OpChangeState
       
    //#endregion


    //#region Navigation properties

    public device: OpDevice
    public meter: OpMeter
    public location: OpLocation
    public actionType: OpActionType
    public actionStatus: OpActionStatus
    public actionData: OpActionData
    public module: OpModule
    public operator: OpOperator

    //#endregion


    //#region Ctor

    constructor(opObj: any) {
        this.fromJSON(opObj)
    }

    //#endregion

    
    //#region IReferenceType implementation

    public getReferenceType(): Enums.ReferenceType {
        return Enums.ReferenceType.IdAction
    }
    public getReferenceKey(): number {
        return this.idAction
    }
    public getReferenceValue(): any {
        return this
    }

    //#endregion


    //#region IOpObject implementation

    public get idObject(): number {
        return this.idAction
    }

    public set idObject(value: number) {
        this.idAction = value
    }

    public dataList: OpDataList<OpActionData> = new OpDataList<OpActionData>()

    public dynamicValues: { Key: string, Value: any }[] = []

    public customFormatString: string;

    public toString(): string {
        let customFormatString = ObjectCustomString.getCustomStringFormat(this)

        if (!customFormatString) {
            return LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Action) + this.idAction.toString()
        }
        else {
            return ObjectCustomString.getObjectCustomString(customFormatString, this)
        }
    }

    //#endregion


    //#region IJsonSerializer Implementation
    
    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj != null) {
            this.idAction = opObj.ID_ACTION
            this.idActionData = opObj.ID_ACTION_DATA
            this.idActionParent = opObj.ID_ACTION_PARENT
            this.idActionStatus = opObj.ID_ACTION_STATUS
            this.idActionType = opObj.ID_ACTION_TYPE
            this.idLocation = opObj.ID_LOCATION
            this.idMeter = opObj.ID_METER
            this.idOperator = opObj.ID_OPERATOR
            this.idModule = opObj.ID_MODULE
            this.dynamicValues = opObj.dynamicValues
            this.actionData = (opObj._ActionData != null) ? new OpActionData(opObj._ActionData) : null
            this.actionStatus = (opObj._ActionStatus != null) ? new OpActionStatus(opObj._ActionStatus) : null
            this.actionType = (opObj._ActionType != null) ? new OpActionType(opObj._ActionType) : null
            this.device = (opObj._Device != null) ? new OpDevice(opObj._Device) : null
            this.location = (opObj._Location != null) ? new OpLocation(opObj._Location) : null
            this.meter = (opObj._Meter != null) ? new OpMeter(opObj._Meter) : null
            this.module = (opObj._Module != null) ? new OpModule(opObj._Module) : null
            this.operator = (opObj._Operator != null) ? new OpOperator(opObj._Operator) : null
            if (opObj.DataList != null) {
                this.dataList.push(...opObj.DataList.map(data => new OpActionData(data)))
            }
        }
    }

    public toJSON(compressed: boolean = false): any {
        return {
            ID_ACTION: this.idAction,
            ID_ACTION_DATA: this.idActionData,
            ID_ACTION_PARENT: this.idActionParent,
            ID_ACTION_STATUS: this.idActionStatus,
            ID_ACTION_TYPE: this.idActionType,
            ID_LOCATION: this.idLocation,
            ID_METER: this.idMeter,
            ID_OPERATOR: this.idOperator,
            ID_MODULE: this.idModule,
            dynamicValues: this.dynamicValues,
            _ActionData: (this.actionData != null) ? this.actionData.toJSON(compressed) : null,
            _ActionStatus: (this.actionStatus != null) ? this.actionStatus.toJSON(compressed) : null,
            _ActionType: (this.actionType != null) ? this.actionType.toJSON(compressed) : null,
            _Device: (this.device != null) ? this.device.toJSON(compressed) : null,
            _Location: (this.location != null) ? this.location.toJSON(compressed) : null,
            _Meter: (this.meter != null) ? this.meter.toJSON(compressed) : null,
            _Module: (this.module != null) ? this.module.toJSON(compressed) : null,
            _Operator: (this.operator != null) ? this.operator.toJSON(compressed) : null,
            DataList: (this.dataList != null) ? this.dataList.ToJSON(compressed) : [],                
            
        }
    }

    //#endregion

}